function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.connectedInputs = document.querySelectorAll(this.input.dataset.connectedInputs);
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (this.connectedInputs) {
      this.connectedInputs.forEach(connectedInput => {
        connectedInput.addEventListener('change', () => {
          this.input.value = connectedInput.value;
          this.input.dispatchEvent(this.changeEvent);
        })
      });
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      var evt = new Event("cart-changed");
      document.dispatchEvent(evt)
    }

    if (this.connectedInputs) {
      this.connectedInputs.forEach(connectedInput => {
        event.target.name === 'plus' ? connectedInput.stepUp() : connectedInput.stepDown();
      });
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    const header = document.querySelector('.header');
    let headerHeight = 0;

    this.mainDetailsToggle = this.querySelector('details');

    if (!header.classList.contains('header--transparent')) {
      headerHeight = header.offsetHeight
    }

    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    // if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || 0;
    this.transparentHeader = document.querySelector('.header--transparent');
    const wrapper = this.header.querySelector('.header-wrapper')

    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset - wrapper.offsetHeight)}px`);

    this.header.classList.add('menu-open');

    if (this.transparentHeader) {
      this.transparentHeader.classList.remove('header--transparent');
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');

    if (this.transparentHeader) {
      this.transparentHeader.classList.add('header--transparent');
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button') || this;

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      console.log(modal)
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

      if (deferredElement.tagName == 'VIDEO') {
        setTimeout(() => {
          deferredElement.play();
        }, 100)
      }

      if (deferredElement.tagName == 'IFRAME') {
        const src = deferredElement.getAttribute('src')
        const symbol = src.indexOf('?') > -1 ? '&' : '?';

        deferredElement.setAttribute('src', `${src + symbol}autoplay=1`)
      }

      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.config = this.dataset.config || '{}';
    this.slider = this.querySelector('.swiper-container');

    if (!this.slider) return;

    this.swiper = null;
    this.nextButton = this.slider.querySelector('.swiper-button-next')
    this.prevButton = this.slider.querySelector('.swiper-button-prev')

    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.slider, {
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      ...JSON.parse(this.config),
    })
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    console.log("MANOLOOOO", this.currentVariant)
    this.updateOptions();
    this.updateMasterId();
    console.log(this.currentVariant)
    this.toggleAddButton(true, '');
    this.removeErrorMessage();
    this.updateRelatedItems();
    this.updatePrice();
    this.updateBorderSelector();
    this.updateDiscount();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateDiscount(){
    const discountLabel = document.querySelector('.price__badge-sale')
    if(discountLabel){
      const newDiscount = Math.round(100 - (this.currentVariant.price / this.currentVariant.compare_at_price) * 100)
      discountLabel.querySelector(".price--discount-perc").innerHTML = newDiscount+"%"
    }
  }

  updateBorderSelector(){
    try{
      const variantsData = this.getVariantData()
      const currentSizeVariants = variantsData.filter(variant=>{
        return variant.option1 == this.currentVariant.option1
      })
  
      var containsSquare = false
      var containsRound = false
      currentSizeVariants.forEach(variant=>{
        if(variant.option2.includes("Redondo") || variant.option2.includes("Round") || variant.option2.includes("Rond")){
          containsRound = true
        }
        if(!variant.option2.includes("Redondo") && !variant.option2.includes("Round") && !variant.option2.includes("Rond")){
          containsSquare = true
        }
      })
  
      if(containsRound){
        document.querySelector('border-toggler .js-toggle-round').removeAttribute("style")
      }else{
        document.querySelector('border-toggler .js-toggle-round').setAttribute("style", "display: none;")
      }
  
      if(containsSquare){
        document.querySelector('border-toggler .js-toggle-square').removeAttribute("style")
      }else{
        document.querySelector('border-toggler .js-toggle-square').setAttribute("style", "display: none;")
      }
    }catch(e){}
  }

  updatePrice() {
    const priceContainer = document.getElementById(`price-${this.dataset.section}`);
    const priceItem = priceContainer.querySelector('.price-item--regular');
    const price = this.currentVariant.price
    const compareAtPrice = this.currentVariant.compare_at_price

    if (price < compareAtPrice) {
      const discountPrice = priceContainer.querySelector('.price__sale .price-item.price-item--regular')
      const regularPrice = priceContainer.querySelector('.price-item.price-item--sale.price-item--last')
      if (String(price).slice(-2) == '00') {
        regularPrice.innerHTML = Shopify.formatMoney(price).replace(',00', '');
        regularPrice.setAttribute('data-price' , Shopify.formatMoney(price).replace(',00', ''));
      } else {
        regularPrice.innerHTML = Shopify.formatMoney(price);
        regularPrice.setAttribute('data-price', Shopify.formatMoney(price));
      }

      if (String(compareAtPrice).slice(-2) == '00') {
        discountPrice.innerHTML = Shopify.formatMoney(compareAtPrice).replace(',00', '');
        discountPrice.setAttribute('data-price', Shopify.formatMoney(compareAtPrice).replace(',00', '')) ;
      } else {
        discountPrice.innerHTML = Shopify.formatMoney(compareAtPrice);
        discountPrice.setAttribute('data-price', Shopify.formatMoney(compareAtPrice));
      }
    } else {
      if (String(price).slice(-2) == '00') {
        priceItem.innerHTML = Shopify.formatMoney(price).replace(',00', '');
        priceItem.setAttribute('data-price', Shopify.formatMoney(price).replace(',00', ''));
      } else {
        priceItem.innerHTML = Shopify.formatMoney(price);
        priceItem.setAttribute('data-price' , Shopify.formatMoney(price));
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });


    if(!this.currentVariant){
      this.currentVariant = this.getVariantData().find((variant) => {
        console.log(variant.options)
        return !variant.options.map((option, index) => {
          if(index == 1){
            console.log(this.options[index], option)
            return option.includes(this.options[index]);
          }else{
            return this.options[index] === option;
          }
        }).includes(false);
      });

      console.log(this.currentVariant)
    }
  }

  updateRelatedItems() {
    const container = document.querySelector(`#ProductRelated-${this.dataset.section}`);
    const sliders = container.querySelectorAll(`slider-component[data-variant-id]`);

    sliders.forEach(slider => slider.classList.toggle('active', slider.dataset.variantId == this.currentVariant.id));
  }

  updateMedia() {
    const mediaContainer = document.querySelector(`#ProductMedia-${this.dataset.section}`);
    const grid = mediaContainer.querySelector('.product__images-grid');
    // "Product Info - SC" (main-product-sc) no tiene grid de fotos: sin esta guarda, cambiar de
    // variante lanzaría un error aquí y cortaría el resto de updateMedia.
    const gridImages = grid ? grid.querySelectorAll('.product__image') : [];

    const slidersContainer = mediaContainer.querySelector('.product__images');
    const slides = slidersContainer.querySelectorAll('.swiper-wrapper > div');

    gridImages.forEach(image => {
      if (image.hasAttribute('data-variants')) {
        const imageVariants = JSON.parse(image.dataset.variants) || [];

        if (imageVariants.includes(this.currentVariant.id + '')) {
          const div = document.createElement('div');
          div.classList.add('product__image');
          div.dataset.variants = image.dataset.variants;
          div.dataset.slideIndex = image.dataset.slideIndex;
          div.innerHTML = image.innerHTML

          image.replaceWith(div)
        } else {
          const span = document.createElement('span');
          span.classList.add('product__image', 'hidden');
          span.dataset.variants = image.dataset.variants;
          span.innerHTML = image.innerHTML

          image.replaceWith(span)
        }
      }
    });

    slides.forEach(slide => {
      if (slide.hasAttribute('data-variants')) {
        const imageVariants = JSON.parse(slide.dataset.variants) || [];

        if (!imageVariants.includes(this.currentVariant.id + '')) {
          slide.classList.add('hidden');
          slide.classList.remove('swiper-slide', 'swiper-slide-visible', 'swiper-slide-active');
        } else {
          slide.classList.remove('hidden');
          slide.classList.add('swiper-slide');
        }
      }
    });

    if (window.sliders.galleryThumbs && window.sliders.galleryMain) {
      window.sliders.galleryThumbs.update();
      window.sliders.galleryThumbs.updateSize();
      window.sliders.galleryThumbs.updateSlides();
      window.sliders.galleryThumbs.updateProgress();
      window.sliders.galleryThumbs.updateSlidesClasses();
      window.sliders.galleryThumbs.slideTo(0);

      window.sliders.galleryMain.update();
      window.sliders.galleryMain.updateSize();
      window.sliders.galleryMain.updateSlides();
      window.sliders.galleryMain.updateProgress();
      window.sliders.galleryMain.updateSlidesClasses();
      window.sliders.galleryMain.slideTo(0);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((response) => {
        console.log(response)
        this.toggleDiscountText(response)
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleDiscountText(response){
    const html = new DOMParser().parseFromString(response, "text/html")
    document.querySelector('.product__discount-outer').innerHTML = html.querySelector('.product__discount-outer').innerHTML
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    const available = document.getElementById(`available-${this.dataset.section}`);
    // const selectedMessage = this.currentVariant && document.getElementById(`variant-data-messages--${this.currentVariant.id}`)
    // if(available.querySelector('span')){
    //   available.querySelector('span').innerText = selectedMessage.dataset.variantMessage
    // }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (available) available.classList.add('visibility-hidden')
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (available) available.classList.remove('visibility-hidden')
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    if (addButton) addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked) ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : fieldset.querySelector("select").value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class Tabs extends HTMLElement {
  constructor() {
    super();

    this.nav = this.querySelector('.tabs__nav')
    this.triggers = this.nav.querySelectorAll('a')
    this.tabs = this.querySelectorAll('.tab');

    this.triggers.forEach(
      (trigger) => trigger.addEventListener('click', this.onTriggerClick.bind(this))
    );
  }

  onTriggerClick(event) {
    event.preventDefault();
    const trigger = event.target;
    const targetSelector = trigger.getAttribute('href') || trigger.dataset.target;
    const target = this.querySelector(targetSelector);

    if (!target) return;

    this.handleTabsChange(target, trigger);
  }

  handleTabsChange(target, trigger) {
    this.tabs.forEach(tab => {
      tab.classList.toggle('active', tab == target);
    });

    this.triggers.forEach(el => {
      el.classList.toggle('active', el == trigger);
    });
  }
}

customElements.define('component-tabs', Tabs);
